import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import LayoutContainer from 'components/Common/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import Heading from 'LuxKit/Typography/Heading'
import Colour from 'components/utils/Colour'
import Group from 'components/utils/Group'
import { useAppSelector } from 'hooks/reduxHooks'
import LoyaltyProgramNameLogo from 'loyalty/components/LoyaltyProgramNameLogo'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const HeroSection = styled.div`
  padding: ${rem(60)} 0;
  background: ${props => props.theme.palette.product.loyalty.silver.gradientPrimaryBackground};
`

interface Props {
  onActivate?: () => void
}

function LoyaltyUserSilverHero(props: Props) {
  const { onActivate } = props
  const firstName = useAppSelector(state => state.auth.account.givenName)
  return <HeroSection>
    <LayoutContainer variant="medium">
      <VerticalSpacer gap={16} style={{ position: 'relative' }}>
        <Group direction="horizontal" gap={12} verticalAlign="center">
          <LoyaltyProgramNameLogo width={104} />
          <LoyaltyTierLabel kind="primary" tier="silver">
            EXCLUSIVE INVITE
          </LoyaltyTierLabel>
        </Group>
        <Group
          direction="vertical"
          tabletDirection="horizontal"
          tabletHorizontalAlign="space-between"
          gap={24}
          tabletGap={16}
        >
          <VerticalSpacer gap={16}>
            <Heading variant="heading1" format="propercase">
              {firstName && <i>{firstName}, </i>}you've unlocked<br />
              <Colour value="tier-silver-light-contrast">Silver status</Colour>
            </Heading>
            <Heading variant="heading4">
              Congratulations, you’re been fast tracked to Silver{' '}
              as a thank you for being one of our valued customers.
            </Heading>
          </VerticalSpacer>
          <Group
            direction="vertical"
            horizontalAlign="start"
            tabletHorizontalAlign="end"
            tabletVerticalAlign="end"
          >
            <TextButton kind="primary" onClick={onActivate}>
              Activate your free membership
            </TextButton>
          </Group>
        </Group>
      </VerticalSpacer>
    </LayoutContainer>
  </HeroSection>
}

export default LoyaltyUserSilverHero
